import { CONFIG_UPDATE } from 'Reducers/config/types';
import { generateUserAgentHeader, setUrls, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { normalizeConfig } from './normalizer';
export const getConfig = (compatibility, country, app, appVersion, deviceManufacturer = 'none', deviceModel = 'none', osType, osVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.apiUrl + 'v1/config',
            headers: {
                'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
            },
            params: {
                country,
                compatibility,
                deviceManufacturer,
                deviceModel,
            },
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const updateConfig = (compatibility, country = 'US', app, appVersion, deviceManufacturer, deviceModel, osType, osVersion) => {
    return new Promise((resolve, reject) => {
        getConfig(compatibility, country, app, appVersion, deviceManufacturer, deviceModel, osType, osVersion)
            .then((config) => {
            const normalizedConfig = normalizeConfig(config, country, app);
            setUrls(normalizedConfig, country);
            store.dispatch({ type: CONFIG_UPDATE, config: normalizedConfig });
            resolve();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
